import type { ExternalTableSchema } from '@packages/table-builder';

type TableColumn = NonNullable<ExternalTableSchema['columns']>[number];

export const transferTaxCertColumn: TableColumn = {
  field: 'isTaxCertificationVerified',
  header: 'Tax Certification',
  type: 'custom',
  sortable: true,
  width: 200,
  align: 'center',
  renderer: 'transferTaxCertification',
};
